import { Col, Row } from "antd";
import { VendorDetails } from "../../../../../features/Vendor/vendor.type";
import { formatDate } from "../../../../../lib/time";

const GeneralDetails = ({ data }: { data: Partial<VendorDetails> }) => {
  const infos = [
    [
      { label: "Business Name", value: data?.business_name },
      { label: "Email", value: data?.email },
      { label: "Address", value: data?.full_address },
    ],
    [
      { label: "Service Type", value: data?.serviceType?.service_type_name },
      { label: "Registration Date", value: formatDate(data?.created_at) },
    ],
  ];

  return (
    <div className="space-y-6 border border-indigo-50 p-5 mt-5 rounded-xl">
      <h5 className="text-lg text-theme-gray-2 font-semibold">
        Vendor Overview
      </h5>
      <Row gutter={[16, 16]}>
        {infos?.map((info, index) => {
          return (
            <Col key={index} span={12} className="space-y-4">
              {info?.map(({ label, value }, index) => (
                <div key={index} className="space-y-1.5">
                  <p className="text-theme-gray-500 text-sm">{label}</p>
                  <p className="block text-theme-gray-900 !text-base font-medium">
                    {value}
                  </p>
                </div>
              ))}
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default GeneralDetails;
